import * as moment from 'moment';

export const layerStyles = () => {
let capas = [
    {
      id: 0, idcapa: null, typelayer: 'raster', name: 'esri',
      layer: {
        'id': 'esri',
        'type': 'raster',
        'source': 'esri',
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 19, tipo: 'base'
    },
    {
      id: 40, idcapa: null, typelayer: 'raster', name: 'googleHybrid',
      layer: {
        'id': 'googleHybrid',
        'type': 'raster',
        'source': 'googleHybrid',
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 19, tipo: 'base'
    },
    {
      id: 1, idcapa: null, typelayer: 'raster', name: 'open',
      layer: {
        'id': 'open',
        'type': 'raster',
        'source': 'open',
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 19, tipo: 'base'
    },
    {
      id: 2, idcapa: null, typelayer: 'raster', name: 'conabio',
      layer: {
        'id': 'conabio',
        'type': 'raster',
        'source': 'conabio',
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'base'
    },
    {
      id: 3, idcapa: null, typelayer: 'raster', name: 'empty',
      layer: {
        "id": "background",
        "type": "background",
        "paint": {
          "background-color": "#1d1f20"
        }
      }, zoom: 16, simbologia: 20, tipo: 'base'
    },
    {
      id: 4, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'pcalor',
      layer: {
        'id': 'pcalor',
        'type': 'circle',
        'layout': {
          'visibility': 'visible'
        },
        'source': 'pcalor',
        /*filter: [
          "all",
          ['>=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 00:00:00`, "YYYY-MM-DD HH:mm:ss").unix()],
          ['<=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 23:59:59`, "YYYY-MM-DD HH:mm:ss").unix()]
        ],*/
        'source-layer': 'pcalor01',
        'filter': ['in', 'd0', null],
        'paint': {
          'circle-color': [
            'case',
          ['boolean', ['feature-state', 'hover'], false],
          'blue',
          [
            'match',
            ['get', 'tipo'],
            'diurno',
            '#ebed04',
            'nocturno',
            '#f21a0f',
          /* other */ '#ccc'
          ]
        ],
          //'circle-radius': 2,
          'circle-radius': [
            'case',
            ['boolean', ['feature-state', 'hover'], true],
            3,
            2
        ],
          'circle-stroke-width': 1,
          'circle-stroke-color': [
            'match',
            ['get', 'tipo'],
            'diurno',
            '#ebed04',
            'nocturno',
            '#f21a0f',
          /* other */ '#ccc'
          ]
          /*'circle-stroke-color': [
            'match',
            ['get', 'tipo'],
            'diurno',
            'red',
            'nocturno',
            '#000000',
            '#ccc'
          ]*/
        }
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 32, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'pcalorfiltro',
      layer: {
        'id': 'pcalorfiltro',
        'type': 'circle',
        'source': 'pcalorfiltro',
        /*filter: [
          "all",
  
          ['>=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 00:00:00`, "YYYY-MM-DD HH:mm:ss").unix()],
          ['<=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 23:59:59`, "YYYY-MM-DD HH:mm:ss").unix()]
        ],*/
        filter: [
          "all",
          ['>=', 'f4', moment.utc("2021-04-14 00:00:00").unix()],
          ['<=', 'f4', moment.utc("2021-04-14 23:59:59").unix()]
        ],
        'layout': {
          'visibility': 'visible'
        },
        'source-layer': 'pcalor01',
        'paint': {
          'circle-color': [
            'match',
            ['get', 'f5'],
            moment().subtract(0, 'days').format('YYYY-MM-DD'),
            '#800026',
            moment().subtract(1, 'days').format('YYYY-MM-DD'),
            '#bd0026',
            moment().subtract(2, 'days').format('YYYY-MM-DD'),
            '#e31a1c',
            moment().subtract(3, 'days').format('YYYY-MM-DD'),
            '#fc4e2a',
            moment().subtract(4, 'days').format('YYYY-MM-DD'),
            '#fd8d3c',
            moment().subtract(5, 'days').format('YYYY-MM-DD'),
            '#feb24c',
            moment().subtract(6, 'days').format('YYYY-MM-DD'),
            '#fed976',
            moment().subtract(7, 'days').format('YYYY-MM-DD'),
            '#ffeda0',
            moment().subtract(8, 'days').format('YYYY-MM-DD'),
            '#ffffcc',
          /* other */ 'blue'
          ],
          'circle-radius': {
            'base': 2,
            'stops': [
              [12, 2],
              [22, 180]
            ]
          },
          //'circle-stroke-width': 1,
          //'circle-stroke-color': '#000000'
          /*'circle-stroke-color': [
            'match',
            ['get', 'tipo'],
            'diurno',
            'red',
            'nocturno',
            '#000000',*/
          /* other */ /*'#ccc'
        ]*/
        }
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 5, idcapa: null, typelayer: 'raster', name: 'puntosxcluster',
      layer: {
        'id': 'puntosxcluster',
        'type': 'raster',
        'source': 'puntosxcluster',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 12
      }, zoom: 12, simbologia: 20, tipo: 'general'
    },
    {
      id: 6, idcapa: null, typelayer: 'raster', name: 'puntosestables',
      layer: {
        'id': 'puntosestables',
        'type': 'raster',
        'source': 'puntosestables',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 7, idcapa: null, typelayer: 'raster', name: 'pCalor10pc1hr',
      layer: {
        'id': 'pCalor10pc1hr',
        'type': 'raster',
        'source': 'pCalor10pc1hr',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 8, idcapa: null, typelayer: 'raster', name: 'heatmap24h',
      layer: {
        'id': 'heatmap24h',
        'type': 'raster',
        'source': 'heatmap24h',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 9, idcapa: null, typelayer: 'raster', name: 'stacker24h',
      layer: {
        'id': 'stacker24h',
        'type': 'raster',
        'source': 'stacker24h',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 12
      }, zoom: 12, simbologia: 20, tipo: 'general'
    },
    {
      id: 10, idcapa: null, typelayer: 'raster', name: 'humedadIdHrgbA',
      layer: {
        'id': 'humedadIdHrgbA',
        'type': 'raster',
        'source': 'humedadIdHrgbA',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 17
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 11, idcapa: null, typelayer: 'raster', name: 'catFinalNDVI',
      layer: {
        'id': 'catFinalNDVI',
        'type': 'raster',
        'source': 'catFinalNDVI',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 12, idcapa: null, typelayer: 'raster', name: 'modisFalseColor',
      layer: {
        'id': 'modisFalseColor',
        'type': 'raster',
        'source': 'modisFalseColor',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 13, idcapa: null, typelayer: 'raster', name: 'viirsFalseColor',
      layer: {
        'id': 'viirsFalseColor',
        'type': 'raster',
        'source': 'viirsFalseColor',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 14, idcapa: null, typelayer: 'raster', name: 'viirsTrueColor',
      layer: {
        'id': 'viirsTrueColor',
        'type': 'raster',
        'source': 'viirsTrueColor',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 15, idcapa: null, typelayer: 'raster', name: 'viirsTrueColor',
      layer: {
        'id': 'viirsTrueColor',
        'type': 'raster',
        'source': 'viirsTrueColor',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 16, idcapa: null, typelayer: 'raster', name: 'aq2000_2019',
      layer: {
        'id': 'aq2000_2019',
        'type': 'raster',
        'source': 'aq2000_2019',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 17, idcapa: null, typelayer: 'raster', name: 'aq2000_2019ca',
      layer: {
        'id': 'aq2000_2019ca',
        'type': 'raster',
        'source': 'aq2000_2019ca',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 18, idcapa: null, typelayer: 'raster', name: 'nalcms',
      layer: {
        'id': 'nalcms',
        'type': 'raster',
        'source': 'nalcms',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 19, idcapa: null, typelayer: 'raster', name: 'indiceAmenazaReclass',
      layer: {
        'id': 'indiceAmenazaReclass',
        'type': 'raster',
        'source': 'indiceAmenazaReclass',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 20, idcapa: null, typelayer: 'raster', name: 'lucesEstablesMex',
      layer: {
        'id': 'lucesEstablesMex',
        'type': 'raster',
        'source': 'lucesEstablesMex',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 21, idcapa: null, typelayer: 'raster', name: 'lucesRasterCA',
      layer: {
        'id': 'lucesRasterCA',
        'type': 'raster',
        'source': 'lucesRasterCA',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 88, idcapa: null, typelayer: 'vector', entitielayer: 'poligon', name: 'aqmodis',
      /*layer:{
        'id': 'anp',
        'type': 'raster',
        'source': 'anp',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general' },*/
      layer: {
        'id': 'aqmodis',
        'type': 'fill',
        'layout': {
          'visibility': 'visible'
        },
        'source': 'aqmodis',
        'source-layer': 'aqmodis',
        'paint': {
          //'fill-color': '#507f3d',
          'fill-color': [
            'case',
          ['boolean', ['feature-state', 'hover'], false],
          'blue',
          '#507f3d'
            ],
          'fill-opacity': .6,
          'fill-outline-color': 'black'
        },
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 22, idcapa: null, typelayer: 'vector', entitielayer: 'poligon', name: 'anp',
      /*layer:{
        'id': 'anp',
        'type': 'raster',
        'source': 'anp',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general' },*/
      layer: {
        'id': 'anp',
        'type': 'fill',
        'layout': {
          'visibility': 'visible'
        },
        'source': 'anptest',
        'source-layer': 'anp',
        'paint': {
          //'fill-color': '#507f3d',
          'fill-color': [
            'case',
          ['boolean', ['feature-state', 'hover'], false],
          'blue',
          '#507f3d'
            ],
          'fill-opacity': .6,
          'fill-outline-color': 'black'
        },
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 23, idcapa: null, typelayer: 'raster', name: 'centrosRegionales',
      layer: {
        'id': 'centrosRegionales',
        'type': 'raster',
        'source': 'centrosRegionales',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 24, idcapa: null, typelayer: 'raster', name: 'ap2014dissv2',
      layer: {
        'id': 'ap2014dissv2',
        'type': 'raster',
        'source': 'ap2014dissv2',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 25, idcapa: null, typelayer: 'raster', name: 'paisEstado',
      layer: {
        'id': 'paisEstado',
        'type': 'raster',
        'source': 'paisEstado',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 26, idcapa: null, typelayer: 'raster', name: 'modisTrueColor',
      layer: {
        'id': 'modisTrueColor',
        'type': 'raster',
        'source': 'modisTrueColor',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 27, idcapa: null, typelayer: 'raster', name: 'viirsTrueColor',
      layer: {
        'id': 'viirsTrueColor',
        'type': 'raster',
        'source': 'viirsTrueColor',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 28, idcapa: null, typelayer: 'raster', name: 'viirsNight',
      layer: {
        'id': 'viirsNight',
        'type': 'raster',
        'source': 'viirsNight',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 29, idcapa: null, typelayer: 'raster', name: 'burnday',
      layer: {
        'id': 'burnday',
        'type': 'raster',
        'source': 'burnday',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 30, idcapa: null, typelayer: 'vector', name: 'pcalor10',
      layer: {
        id: 'pcalor10',
        type: 'circle',
        source: 'pcalor10',
        /*filter: [
          "all",
          ['>=', 'f3',moment.utc(`${moment().subtract(10, 'days').format('YYYY-MM-DD')} 00:00:00`, "YYYY-MM-DD HH:mm:ss").unix()],
          ['<=', 'f3',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 23:59:59`, "YYYY-MM-DD HH:mm:ss").unix()]
        ],*/
        'paint': {
          'circle-color': {
            "property": "f5",
            "stops": [
              [1, 'blue'],
              [2, '#ffffcc'],
              [3, '#ffeda0'],
              [4, '#fed976'],
              [5, '#feb24c'],
              [6, '#fd8d3c'],
              [7, '#fc4e2a'],
              [8, '#e31a1c'],
              [9, '#bd0026'],
              [10, '#800026']
            ]
          },
          'circle-radius': {
            'base': 1.85,
            'stops': [
              [12, 2],
              [22, 180]
            ]
          },
          /*         'circle-stroke-width': 1,
                  'circle-stroke-color': {
                    "property": "f15",
                    "stops": [
                      [1, 'blue'],
                      [2, '#ffffcc'],
                      [3, '#ffeda0'],
                      [4, '#fed976'],
                      [5, '#feb24c'],
                      [6, '#fd8d3c'],
                      [7, '#fc4e2a'],
                      [8, '#e31a1c'],
                      [9, '#bd0026'],
                      [10, '#800026']
                    ]
                  } */
        }
      }
      , zoom: 16, simbologia: 20, tipo: 'pcalor'
    },
    {
      id: 31, idcapa: null, typelayer: 'vector', name: 'pcalorCluster',
      layer: {
        id: 'pcalorCluster',
        type: 'circle',
        source: 'pcalor10',
        /*filter: [
          "all",
          ['>=', 'f4',moment.utc(`${moment().subtract(2, 'days').format('YYYY-MM-DD')} 00:00:00`, "YYYY-MM-DD HH:mm:ss").unix()],
          ['<=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 23:59:59`, "YYYY-MM-DD HH:mm:ss").unix()]
        ],*/
        'paint': {
          'circle-color': {
            "property": "f5",
            "stops": [
              [1, 'blue'],
              [2, '#ffffcc'],
              [3, '#ffeda0'],
              [4, '#fed976'],
              [5, '#feb24c'],
              [6, '#fd8d3c'],
              [7, '#fc4e2a'],
              [8, '#e31a1c'],
              [9, '#bd0026'],
              [10, '#800026']
            ]
          },
          'circle-radius': {
            'base': 1.85,
            'stops': [
              [12, 2],
              [22, 180]
            ]
          },
          /*         'circle-stroke-width': 1,
                  'circle-stroke-color': {
                    "property": "f15",
                    "stops": [
                      [1, 'blue'],
                      [2, '#ffffcc'],
                      [3, '#ffeda0'],
                      [4, '#fed976'],
                      [5, '#feb24c'],
                      [6, '#fd8d3c'],
                      [7, '#fc4e2a'],
                      [8, '#e31a1c'],
                      [9, '#bd0026'],
                      [10, '#800026']
                    ]
                  } */
        }
      }
      , zoom: 16, simbologia: 20, tipo: 'pcalor'
    },
    {
      id: 33, idcapa: null, typelayer: 'vector', entitielayer: 'poligon', name: 'estados',
      layer: {
        'id': 'estados',
        'type': 'fill',
        'layout': {
          'visibility': 'visible'
        },
        'source': 'estadostest',
        'source-layer': 'estados',
        'paint': {
          'fill-color': '#507f3d',
          /*'fill-color': [
            'case',
          ['boolean', ['feature-state', 'hover'], false],
          'blue',
          '#507f3d'
            ],*/
          'fill-opacity': .6,
          'fill-outline-color': 'black'
        },
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 33, tipo: 'general'
    },
    {
      id: 34, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'pcalor',
      layer: {
        'id': 'pcalor01_2021',
        'type': 'circle',
        'layout': {
          'visibility': 'visible'
        },
        'source': 'pcalor01_2021',
        /*filter: [
          "all",
          ['>=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 00:00:00`, "YYYY-MM-DD HH:mm:ss").unix()],
          ['<=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 23:59:59`, "YYYY-MM-DD HH:mm:ss").unix()]
        ],*/
        'source-layer': 'pcalor_2021',
        //'filter': ['in', 'd0', 1],
        'paint': {
          'circle-color': [
            'case',
          ['boolean', ['feature-state', 'hover'], false],
          'blue',
          [
            'match',
            ['get', 'f1'],
            'd',
            '#ebed04',
            'n',
            'red',
          /* other */ '#ccc'
          ]
        ],
          //'circle-radius': 2,
          'circle-radius': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            3,
            2
        ],
          'circle-stroke-width': .5,
          'circle-stroke-color': [
            'match',
            ['get', 'tipo'],
            'diurno',
            '#ebed04',
            'nocturno',
            'red',
          /* other */ '#ccc'
          ]
          /*'circle-stroke-color': [
            'match',
            ['get', 'tipo'],
            'diurno',
            'red',
            'nocturno',
            '#000000',
            '#ccc'
          ]*/
        }
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 35, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'pcalor',
      layer: {
        'id': 'pcalor02_2021',
        'type': 'circle',
        'layout': {
          'visibility': 'visible'
        },
        'source': 'pcalor02_2021',
        /*filter: [
          "all",
          ['>=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 00:00:00`, "YYYY-MM-DD HH:mm:ss").unix()],
          ['<=', 'f4',moment.utc(`${moment().subtract(0, 'days').format('YYYY-MM-DD')} 23:59:59`, "YYYY-MM-DD HH:mm:ss").unix()]
        ],*/
        'source-layer': 'pcalor_2021',
        //'filter': ['in', 'd0', 1],
        'paint': {
          'circle-color': [
            'case',
          ['boolean', ['feature-state', 'hover'], false],
          'blue',
          [
            'match',
            ['get', 'f1'],
            'd',
            '#ebed04',
            'n',
            'red',
          /* other */ '#ccc'
          ]
        ],
          //'circle-radius': 2,
          'circle-radius': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            3,
            2
        ],
          'circle-stroke-width': .5,
          'circle-stroke-color': [
            'match',
            ['get', 'tipo'],
            'diurno',
            '#ebed04',
            'nocturno',
            'red',
          /* other */ '#ccc'
          ]
          /*'circle-stroke-color': [
            'match',
            ['get', 'tipo'],
            'diurno',
            'red',
            'nocturno',
            '#000000',
            '#ccc'
          ]*/
        }
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 36, idcapa: null, typelayer: 'raster', name: 'goesFalseColor',
      layer: {
        'id': 'goesFalseColor',
        'type': 'raster',
        'source': 'goesFalseColor',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 37, idcapa: null, typelayer: 'raster', name: 'goesTrueColor',
      layer: {
        'id': 'goesTrueColor',
        'type': 'raster',
        'source': 'goesTrueColor',
        'paint': {},
        'minzoom': 0,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 100, idcapa: null, typelayer: 'raster', name: 'goes_winds',
      layer: {
        'id': 'goes_winds',
        'type': 'raster',
        'source': 'goes_winds',
        'paint': {},
        'minzoom': 2,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 101, idcapa: null, typelayer: 'raster', name: 'goes_glm',
      layer: {
        'id': 'goes_glm',
        'type': 'raster',
        'source': 'goes_glm',
        'paint': {},
        'minzoom': 2,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 102, idcapa: null, typelayer: 'raster', name: 'goes_rain',
      layer: {
        'id': 'goes_rain',
        'type': 'raster',
        'source': 'goes_rain',
        'paint': {},
        'minzoom': 2,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 103, idcapa: null, typelayer: 'raster', name: 'goes_mh',
      layer: {
        'id': 'goes_mh',
        'type': 'raster',
        'source': 'goes_mh',
        'paint': {},
        'minzoom': 2,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 104, idcapa: null, typelayer: 'raster', name: 'goes_mh_qa',
      layer: {
        'id': 'goes_mh_qa',
        'type': 'raster',
        'source': 'goes_mh_qa',
        'paint': {},
        'minzoom': 2,
        'maxzoom': 22
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },
    {
      id: 105, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'goes_points',
      layer: {
        'id': 'goes_points',
        'type': 'circle',
        'source': 'goes_points',
        'paint': {
                'circle-radius': 4,
                'circle-stroke-width': 2,
                'circle-color': 'red',
                'circle-stroke-color': 'white'
        },
        'minzoom': 2,
        'maxzoom': 22
      }, zoom: 16, simbologia: 105, tipo: 'general'
    },
    {
      id: 106, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'goes_heatmap_points',
      layer: {
        'id': 'goes_heatmap_points',
        'type': 'circle',
        'source': 'goes_heatmap_points',
        'paint': {
                'circle-radius': 4,
                'circle-stroke-width': 2,
                'circle-color': 'red',
                'circle-stroke-color': 'white'
        },
      }, zoom: 16, simbologia: 105, tipo: 'general'
    },
    {
      id: 107, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'goes_heatmap',
      layer: {
        'id': 'goes_heatmap',
        'type': 'circle',
        'source': 'goes_heatmap',
        'paint': {
                'circle-radius': 4,
                'circle-stroke-width': 2,
                'circle-color': 'red',
                'circle-stroke-color': 'white'
        },
      }, zoom: 16, simbologia: 106, tipo: 'general'
    },
    {
      id: 108, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'goes_fdcf_10min',
      layer: {
        'id': 'goes_fdcf_10min',
        'type': 'circle',
        'source': 'goes_fdcf_10min',
        'paint': {
                'circle-radius': 4,
                'circle-stroke-width': 2,
                'circle-color': 'red',
                'circle-stroke-color': 'white'
        },
      }, zoom: 16, simbologia: 20, tipo: 'general'
    },

    {
      id: 109, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'goes_fdcf_heatmap_points',
      layer: {
        'id': 'goes_fdcf_heatmap_points',
        'type': 'circle',
        'source': 'goes_fdcf_heatmap_points',
        'paint': {
                'circle-radius': 4,
                'circle-stroke-width': 2,
                'circle-color': 'red',
                'circle-stroke-color': 'white'
        },
      }, zoom: 16, simbologia: 109, tipo: 'general'
    },
    {
      id: 110, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'goes_fdcf_heatmap',
      layer: {
        'id': 'goes_fdcf_heatmap',
        'type': 'circle',
        'source': 'goes_fdcf_heatmap',
        'paint': {
                'circle-radius': 4,
                'circle-stroke-width': 2,
                'circle-color': 'red',
                'circle-stroke-color': 'white'
        },
      }, zoom: 16, simbologia: 109, tipo: 'general'
    },
    {
      id: 120, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'rave',
      layer: {
        'id': 'rave',
        'type': 'circle',
        'source': 'rave',
        'paint': {
                'circle-radius': 4,
                'circle-stroke-width': 2,
                'circle-color': 'red',
                'circle-stroke-color': 'white'
        },
      }, zoom: 16, simbologia: 120, tipo: 'general'
    },
    {
      id: 121, idcapa: null, typelayer: 'vector', entitielayer: 'point', name: 'rave_24h',
      layer: {
        'id': 'rave_24h',
        'type': 'circle',
        'source': 'rave_24h',
        'paint': {
                'circle-radius': 4,
                'circle-stroke-width': 2,
                'circle-color': 'red',
                'circle-stroke-color': 'white'
        },
      }, zoom: 16, simbologia: 121, tipo: 'general'
    },
    {
      id: 122, idcapa: null, typelayer: 'raster', name: 'pressure',
      layer: {
        'id': 'pressure',
        'type': 'raster',
        'source': 'pressure',
        'paint': {},
        'minzoom': 2,
        'maxzoom': 22
      }, zoom: 16, simbologia: 122, tipo: 'general'
    },


  ]
  return capas
}